export function appUrl(state) {
  return state.appUrl;
}
